import React from 'react'
import BlueHeading from "../other/common/BlueHeading";
import Heading from "../common/ui/Heading";
const HeroTerms = () => {
  return (
    <>
      <div className="bg-cover bg-no-repeat bg-center bg-privacy-terms px-4">
        <div className="max-w-[1140px] mx-auto py-[142px]  max-lg:py-32 max-md:py-24 max-sm:py-14">
          <div className="max-w-[620px] mx-auto flex items-center justify-center flex-col">
            <BlueHeading
              text="Terms of Conditions"
              textClass="text-white"
              lineClassOne="!bg-white"
              lineClassTwo="!bg-white"
            />
            <Heading
              children="Terms of Conditions"
              className="mt-4 text-white"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default HeroTerms